module.exports = __webpack_public_path__ + "img/Chinese-Tech-Company-Valuation.b1ab0eef.png";